import Cookies from 'js-cookie';
export default {

    getSessionCookie : function(){
        return Cookies.get('ilm_logged');
    },

    setSessionCookie: function(){
        Cookies.set('ilm_logged', true );
    },

    arrayFromObjectsKey : function(obj , key){
        let arr = [];
        if(obj){
            Object.keys(obj).map(function(objectKey, index) {
                var value = obj[objectKey];
                if(value.hasOwnProperty(key)){
                    arr.push(value[key]);
                }
                return true;
            });
        }
        return arr;
    },

    dataExists : function( dataset ){
        let dataExists = false;
        if(dataset.length > 0){
            // Array reduce to a bollean value        
            dataExists = dataset.reduce( ( dataExist , obj ) => {
                let keys = Object.keys(obj).filter((key)=>{
                    return key.substring(0,3) === '_20'; // 
                });

                return keys.reduce( ( y , year)=>{
                    return obj[year][0] !== '';
                }, false);

            } , false);
        }
        return dataExists ;
    },

    filterDataByProp : function(data , propName, propVal ){

        let filtered = data.filter((item)=>{
        //    if(item.hasOwnProperty(propName) && item[propName.length ]){
        //         return (item[propName][0] === propVal)
        //    }else{
        //        return item;
        //    }
            // console.log(data);
            // console.log(item);
            // console.log(propName);
            // console.log(item[propName]);
            
            return (item[propName][0] === propVal)
        })

        return filtered;

    },

    sortAlphabetically : function(arr , prop ){
        return arr.sort(function(a,b){
            let alc = a.toLowerCase(), blc = b.toLowerCase();
            return alc > blc ? 1 : alc < blc ? -1 : 0;
        });
    },

    sortAlphabeticallyArray : function(arr , prop ){
        return arr.sort(function(a,b){
            let alc = a[prop][0].toLowerCase(), blc = b[prop][0].toLowerCase();
            return alc > blc ? 1 : alc < blc ? -1 : 0;
        });
    },

    cleanString : function(text){
        if(typeof text === 'string'){
            
            //text = text.trim();
            text =  text.replace(/-/g, '_');
            text =  text.replace(/ /g, '_');
            text = text.replace(/[^\w\s]/gi, '');
            text = text.toLowerCase();

        }
        return text;
    },

    parseXmlToJson: function(resultsData, parseString){        
        // This function receive an array of results from Axios (multiple requests)
        // it iterates through the array and for each item it add a 
        // property (named after the original request) to a new object
        // It finally returns the object
        let obj = {}
        if(typeof parseString === 'function'){
            for (var i = 0, len = resultsData.length; i < len; i++) {
                // get the name of teh file originally requested
                let originalFileName = resultsData[i]['config']['url'].substr(resultsData[i]['config']['url'].lastIndexOf('/') + 1);
                originalFileName = originalFileName.replace('.xml' , '');
                // Parse into JSON with xml2jsonparseString
                parseString(resultsData[i]['data'], (err, result)=>{
                    // Use the originalFileName as property name for teh data
                    obj[originalFileName] = result.root.row;
                });
            }
        }
        return obj;
    }


}


// WEBPACK FOOTER //
// ./src/js/utils.js